export default __webpack_public_path__ + "static/media/ols_pattern.72fbd80d.png";